<div class="modal--wrap"
     ngxModalDraggable
     (modalExpand$)="modalExpand($event)"
     (modalMinimize$)="modalMinimize($event)"
>
  <app-modal-header
    [icon]="headerIcon"
    [title]="interfaceService.getChatTitle(chat)"
    theme="dark"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="true"
  ></app-modal-header>
  <div #wrap class="calc--wrap modal-body" [class.hidden]="!callService.isCall">
    <div *ngIf="statusText" class="calc-info">
      <app-avatar
        *ngIf="webrtcService.usersVideoList?.length <= 1"
        [id]="chat?.id"
        [type]="chat.type"
        [avatar]="chat.avatar"
        [avatarFileId]="chat.avatar_file_id"
        [avatarFileUniqueId]="chat.avatar_file_unique_id"
        class="avatar avatar-lg mb-5"
      ></app-avatar>
      <h5 class="text-white" *ngIf="chat?.name || chat?.title">
          <span
            [innerHTML]="interfaceService.getChatTitle(chat) | replaceEmojis: 'facebook':20:64"
          ></span>
      </h5>
      <span *ngIf="statusText" class="text-muted">{{statusText}}</span>
    </div>

    <div *ngIf="webrtcService.usersVideoList.length != 2; else twoUsersRef"
         class="video-grid--wrap d-flex align-items-center">
      <ngx-masonry [style.width.px]="containerWidth" [options]="myOptions"
                   class="users-count-{{webrtcService.usersVideoList.length}}">
        <app-stream-user-item [style.width.px]="user.width" [style.height.px]="user.height"
                              [attr.user-id]="user.userId" ngxMasonryItem
                              *ngFor="let user of webrtcService.usersVideoList; trackBy: trackByFn; let i = index"
                              class="grid-item" (toggleMuteUser)="toggleMuteUser($event)" [user]="user" [chat]="chat"
                              [Service]="Service"></app-stream-user-item>
      </ngx-masonry>
    </div>
    <ng-template #twoUsersRef>
      <div class="video-grid--two users-count-{{webrtcService.usersVideoList.length}}">
        <app-stream-user-item class="stream-user--two grid-item" (toggleMuteUser)="toggleMuteUser($event)"
                              [attr.user-id]="webrtcService.getUserCallBuId('self', true).userId"
                              [user]="webrtcService.getUserCallBuId('self', true)" [chat]="chat"
                              [Service]="Service"></app-stream-user-item>
        <app-stream-user-item class="stream-user--self grid-item" (toggleMuteUser)="toggleMuteUser($event)"
                              [attr.user-id]="webrtcService.getUserCallBuId().userId"
                              [user]="webrtcService.getUserCallBuId()"
                              [chat]="chat" [Service]="Service"></app-stream-user-item>
      </div>
    </ng-template>
    <div class="bottom-panel text-center">

      <button
        placement="top"
        tooltip=""
        [tooltip]="isMute ? 'Включить&nbsp;звук' : 'Без&nbsp;звука'"
        [disabled]="!webrtcService.localStream"
        class="btn {{isMute ? 'btn-danger' : ' btn-dark'}} btn-ico rounded-circle mx-2"
        (click)="toggleMuteUser('self')"
        id="mute-call"
      >
        <i-feather [name]="isMute ? 'mic-off' : 'mic'"></i-feather>
      </button>


      <button
        placement="top"
        [tooltip]="isVideoDisable ? 'Включить&nbsp;видео' : 'Отключить&nbsp;видео'"
        [disabled]="!webrtcService.localStream"
        class="btn {{isVideoDisable ? 'btn-danger' : ' btn-dark'}} btn-ico rounded-circle mx-2"
        (click)="toggleVideoUser('self')"
        id="mute-call-video"
      >
        <i-feather [name]="isVideoDisable ? 'video-off' : 'video'"></i-feather>
      </button>
      <button
        placement="top"
        [tooltip]="!isScreenShare ? 'Демонстрация&nbsp;экрана' : 'Отключить демонстрацию'"
        *ngIf="webrtcService.isSupportShareScreen"
        [disabled]="!webrtcService.localStream"
        class="btn {{isScreenShare ? 'btn-primary' : ' btn-dark'}} btn-ico rounded-circle mx-2"
        (click)="toggleShareScreen()"
        id="mute-call-share"
      >
        <i-feather [name]="'monitor'"></i-feather>
      </button>

      <!--<button
        *ngIf="!localStream"
        [disabled]="myPeer?.disconnected"
        class="btn btn-success btn-ico rounded-circle mx-2"
        (click)="init('fd937d36-fbc6-4a68-b3b7-599941cf3a66')"
        id="make-call"
      >
        <i-feather name="phone-call"></i-feather>
      </button>-->
      <button
        placement="top"
        tooltip="Завершить&nbsp;звонок"
        [disabled]="!webrtcService.localStream" (click)="callService.endCall$.next()"
        class="btn btn-danger btn-ico rounded-circle mx-2"
        id="end-call">
        <i-feather name="phone-off"></i-feather>
      </button>
    </div>
  </div>
</div>
